export default __webpack_public_path__ + "static/media/appleber.33d1abc1.png";